export default "__VITE_ASSET__CFNxx1hF__"